import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { apiService } from 'app/services/api.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {
  aboutUsContent: any;

  constructor(private api: apiService, private metaService: Meta) { }

  ngOnInit() {
    // Assuming 'languageCode' is stored in localStorage
      const languageCode = localStorage.getItem('languageCode') || 'en'; // Use 'en' as default if not found

      this.api.getPageCode().subscribe(pageCode => {
        const aboutUsPageCode = 'About_Us';

        this.api.getPageContent(aboutUsPageCode, languageCode).subscribe(response => {
          this.aboutUsContent = response.data; // Assign the content to the variable
        });
        this.api.getPageContent(aboutUsPageCode, languageCode).subscribe(response => {
          this.aboutUsContent = response.data; // Assign the content to the variable
          this.metaService.updateTag({
            name: 'title', content: this.aboutUsContent.meta_title
          });

          this.metaService.updateTag({
            name: 'keywords', content: this.aboutUsContent.keywords
          });

          this.metaService.updateTag({
            name: 'description', content: this.aboutUsContent.meta_description
          });
        });
      });
  }

}
